import { render, staticRenderFns } from "./ManageColumnsForm.vue?vue&type=template&id=4668dcae&scoped=true&"
import script from "./ManageColumnsForm.vue?vue&type=script&lang=ts&"
export * from "./ManageColumnsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4668dcae",
  null
  
)

export default component.exports